// ─── Finance Slice ───────────────────────────────────────────────────────────
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import financeService from '../../services/financeService';

export const fetchAccounts = createAsyncThunk('finance/fetchAccounts', async (_, { getState }) => {
  return await financeService.getAccounts(getState().auth.token);
});
export const fetchJournals = createAsyncThunk('finance/fetchJournals', async (_, { getState }) => {
  return await financeService.getJournals(getState().auth.token);
});
export const fetchInvoices = createAsyncThunk('finance/fetchInvoices', async (_, { getState }) => {
  return await financeService.getInvoices(getState().auth.token);
});
export const fetchCashBooks = createAsyncThunk('finance/fetchCashBooks', async (_, { getState }) => {
  return await financeService.getCashBook('all', getState().auth.token);
});
export const createJournal = createAsyncThunk('finance/createJournal', async (data, { getState }) => {
  return await financeService.createJournal(data, getState().auth.token);
});
export const createInvoice = createAsyncThunk('finance/createInvoice', async (data, { getState }) => {
  return await financeService.createInvoice(data, getState().auth.token);
});

const financeSlice = createSlice({
  name: 'finance',
  initialState: {
    accounts: [], journals: [], invoices: [], cashBooks: [],
    loading: false, error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccounts.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchAccounts.fulfilled, (state, action) => { state.loading = false; state.accounts = action.payload; })
      .addCase(fetchAccounts.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchJournals.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchJournals.fulfilled, (state, action) => { state.loading = false; state.journals = action.payload; })
      .addCase(fetchJournals.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchInvoices.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchInvoices.fulfilled, (state, action) => { state.loading = false; state.invoices = action.payload; })
      .addCase(fetchInvoices.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchCashBooks.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchCashBooks.fulfilled, (state, action) => { state.loading = false; state.cashBooks = action.payload; })
      .addCase(fetchCashBooks.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createJournal.fulfilled, (state, action) => { state.journals.unshift(action.payload); })
      .addCase(createInvoice.fulfilled, (state, action) => { state.invoices.unshift(action.payload); });
  },
});

export default financeSlice.reducer;
